<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />
    
    <!-- นำทาง -->
    <v-card elevation="0" class="v-card-bottom-30">
      <v-card-title class="body-1">
        {{ use_language.employee }}
        <v-icon>mdi-chevron-right</v-icon>
        {{ use_language.calculate_salary }}
      </v-card-title>
    </v-card>

    <v-row>
      <v-col cols="12" md="6" lg="7">
        <!-- main employee card -->
        <v-card >
          <v-card-title>
            <v-icon color="blue" size="24">fa-sliders-h</v-icon>
            <span class="ml-2">{{ use_language.search_data }}</span>
            <v-spacer></v-spacer>
            <v-btn color="info" outlined @click="openEmployeeForSetting">{{ use_language.employee_salary_setting }}</v-btn>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col sm="12" md="6" lg="7" class="ma-0 pa-0">
                <v-row class="pl-0 ma-0 pa-0">
                  <v-col class="pl-0 pt-0" cols="12" md="5" lg="5">
                    <v-row >
                      <v-col class="pr-0 pl-0" cols="12" md="4" lg="4"> {{ use_language.month }} : </v-col>
                      <v-col class="pl-0 pr-0" cols="12" md="8">
                        <v-text-field v-model="search.month" outlined dense hide-details></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="pl-0 pt-0" cols="12" md="5" lg="5">
                    <v-row >
                      <v-col class="pr-0 pl-0" cols="12" md="4" lg="4"> {{ use_language.year }} : </v-col>
                      <v-col class="pl-0 pr-0" cols="12" md="8">
                        <v-text-field v-model="search.year" outlined dense hide-details></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="pl-2 pr-0" cols="12" md="2" lg="2">
                    <v-btn  color="primary" @click="getEmployeeSalary">{{ use_language.search }}</v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-col sm="12" md="6" lg="5" class="text-right pr-0">
                <v-btn color="primary" outlined @click="btnCalculateSalary">
                  {{ use_language.add_salary_to_expense }}
                </v-btn>
                <v-btn class="ml-2" color="primary" icon @click="openDialogWaitPayEmployee">
                  <v-icon size="46" >mdi-plus-box</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text style="overflow-y: auto; max-height: calc(100dvh - 90px);">
            <v-data-table
              :headers="employeeHeader"
              :items="employeeList"
              hide-default-footer
              id="datatablexs"
              :items-per-page="50"
              :mobile-breakpoint="0"
              @click:row="rowClick"
            >
              <template v-slot:item.delete="{ item }">
                <a class="color-red" @click="deletePayMaster(item)">
                  <span>{{ use_language.delete }}</span>
                </a>
              </template>
              <template v-slot:item.amount="{ item }">
                <div class="text-right">{{format_price(item.amount)}}</div>
              </template>
              <template v-slot:item.isFulltime="{ item }">
                <div :class="item.isFulltime == use_language.fulltime ? 'color-green' : 'color-orange'">{{item.isFulltime}}</div>
              </template>
              <template v-slot:item.isTakeSocialSecurity="{ item }">
                <div :class="item.isTakeSocialSecurity == use_language.receive ? 'color-green' : 'color-orange'">{{item.isTakeSocialSecurity}}</div>
              </template>
              <template v-slot:item.specialWage="{ item }">
                <div :class="item.specialWage == use_language.diligence_allowance ? 'color-green' : ''">{{item.specialWage}}</div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="5">

        <!-- employee item card -->
        <v-card>
          <v-card-title>
            <div>{{textOfEmployee}}</div>
            <v-spacer></v-spacer>
            <v-btn color="primary" icon @click="openPayItem(null)" :disabled="isAddPayItem==false">
              <v-icon size="46">mdi-plus-box</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="salaryEmployeeHeader"
              :items="salaryEmployeeList"
              hide-default-footer
              id="datatablexs"
              :items-per-page="50"
              :mobile-breakpoint="0"
            >
              <template v-slot:item.edit="{ item }">
                <a v-if="item.id != 0" class="color-orange" @click="openPayItem(item)">
                  <span>{{ use_language.edit }}</span>
                </a>
              </template>
              <template v-slot:item.delete="{ item }">
                <a v-if="item.id != 0" class="color-red" @click="deletePayItem(item)">
                  <span>{{ use_language.delete }}</span>
                </a>
              </template>
              <template v-slot:item.description="{ item }">
                <div :class="item.deduct != '' && item.deduct < 0 ? 'pl-3' : ''">{{item.description}}</div>
              </template>
              <template v-slot:item.payment="{ item }">
                <div class="text-right color-green">
                  <span v-if="item.payment == 0"></span>
                  <span v-else>{{format_price(item.payment)}}</span>
                </div>
              </template>
              <template v-slot:item.deduct="{ item }">
                <div class="text-right color-red">
                  <span v-if="item.deduct == 0"></span>
                  <span v-else>{{format_price(item.deduct)}}</span>
                </div>
              </template>
              <template v-slot:item.total="{ item }">
                <div class="text-right">
                  <span v-if="item.total == 0"></span>
                  <span v-else>{{format_price(item.total)}}</span>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <!-- employer item card -->
        <v-card class="mt-8">
          <v-card-title>
            <div>{{ use_language.payment_list }}</div>
            <v-spacer></v-spacer>
            <v-btn color="primary" icon @click="openAddPayItem" :disabled="isAddPayItem==false">
              <v-icon size="46" >mdi-plus-box</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="salaryEmployerHeader"
              :items="salaryEmployerList"
              hide-default-footer
              id="datatablexs"
              :items-per-page="50"
              :mobile-breakpoint="0"
            >
              <template v-slot:item.delete="{ item }">
                <a v-if="item.id != 0" class="color-red" @click="deleteAddPayItem(item)">
                  <span>{{ use_language.delete }}</span>
                </a>
              </template>
              <template v-slot:item.amount="{ item }">
                <div class="text-right">
                  <span>{{item.amount}}</span>
                </div>
              </template>
              <template v-slot:item.fullBankName="{ item }">
                <div>
                  <span>{{item.isCash == true ? use_language.cash : item.fullBankName}}</span>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>

    <!-- dialog employee wait pay -->
    <v-dialog v-model="dialogWaitPay" scrollable max-width="50%" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1" class="ma-0">
        <v-card-title>
          <v-icon size="40" color="teal darken-3">mdi-account</v-icon>
           <span class="ml-3">{{ use_language.select_employee }}</span>
          <v-spacer/>
          <v-btn icon @click="dialogWaitPay=false, selectedEmployeeWaitPay=[]">
            <v-icon color="danger">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="overflow-y-auto px-5">
          <v-data-table
            v-model="selectedEmployeeWaitPay"
            :headers="employeeWaitPayHeader"
            :items="employeeWaitPayList"
            hide-default-footer
            id="datatablexs"
            :items-per-page="50"
            :mobile-breakpoint="0"
            :single-select="false" 
            show-select
          >
            <template v-slot:item.firstname="{ item }">
              <div>{{item.firstname + ' ' + item.lastname}}</div>
            </template>
            <template v-slot:item.isFulltime="{ item }">
              <div :class="item.isFulltime ? 'color-green' : 'color-orange'">
                {{item.isFulltime ? use_language.fulltime : use_language.parttime}}
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn :elevation="1" color="primary" class="px-2" @click="btnWaitPayEmployee">
                <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
                <span class="fn-14"><b> {{ use_language.button_save }} </b></span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog employee pay item -->
    <v-dialog v-model="dialogPayItem" scrollable max-width="50%" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1" class="ma-0">
        <v-card-title>
          <v-icon size="40" color="teal darken-3">mdi-list-box</v-icon>
           <span class="ml-3">{{ use_language.add_item }}</span>
          <v-spacer/>
          <v-btn icon><v-icon color="danger" @click="closePayItem">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="overflow-y-auto px-5">
          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.employee }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <div>{{payItem.name}}</div>
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.category }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-autocomplete
                v-model="payItem.type" :items="salaryTypeList"
                item-text="text" item-value="id" outlined required hide-details dense
                style="width: 212px"
              >
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.details }} :</span>
            </v-col>
            <v-col cols="12" md="4" class="pt-1 pb-2">
              <v-text-field
                v-model="payItem.description"
                autocomplete="off"
                outlined
                dense hide-details
                style="width: 212px"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5" class="pt-1 pb-2">
              <v-radio-group row v-model="descriptionType" dense hide-details>
                <v-radio :label="use_language.diligence_allowance" :value="1"></v-radio>
                <v-radio :label="use_language.commission" :value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14 color-green">{{ use_language.in }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-text-field
                v-model="payItem.in"
                @keypress="isNumberWithDot($event)"
                autocomplete="off"
                outlined
                dense hide-details
                style="width: 212px"
                class="text-field-in"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14 color-red">{{ use_language.leave }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-text-field
                v-model="payItem.out"
                @keypress="isNumberWithDot($event)"
                autocomplete="off"
                outlined
                dense hide-details
                style="width: 212px"
                class="text-field-out"
              ></v-text-field>
            </v-col>
          </v-row>
          
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn :elevation="1" color="primary" class="px-2" @click="btnUpdatePayItem">
                <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
                <span class="fn-14"><b> {{ use_language.button_save }} </b></span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog employer pay item -->
    <v-dialog v-model="dialogAddPayItem" scrollable max-width="50%" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1" class="ma-0">
        <v-card-title>
          <v-icon size="40" color="teal darken-3">mdi-list-box</v-icon>
           <span class="ml-3">{{ use_language.add_item }}</span>
          <v-spacer/>
          <v-btn icon><v-icon color="danger" @click="closeAddPayItem">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="overflow-y-auto px-5">
          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.date }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-menu
                ref="selected_menu_date"
                v-model="addPayItem.selected_menu_date"
                :close-on-content-click="false"
                :return-value.sync="addPayItem.selected_date"
                offset-y
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="computed_selected_date"
                    @change="value => computed_selected_date = value"
                    autocomplete="off"
                    :label="use_language.start_"
                    outlined
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    hide-details
                    v-on="on"
                    style="width: 290px"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="addPayItem.selected_date" @input="addPayItem.selected_menu_date = false, $refs.selected_menu_date.save(addPayItem.selected_date)" no-title class="my-0">
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.bank }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-autocomplete
                v-model="addPayItem.bankAccountSelected" :items="bankAccountList"
                item-text="text" item-value="id" outlined required hide-details dense
              >
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.note }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-text-field
                v-model="addPayItem.remark"
                autocomplete="off"
                outlined
                dense hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.amount_money }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-text-field
                v-model="addPayItem.amount"
                @keypress="isNumberWithDot($event)"
                autocomplete="off"
                outlined
                dense hide-details
                style="width: 290px"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
         <v-divider />
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn :elevation="1" color="primary" class="px-2" @click="btnAddPayItem">
                <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
                <span class="fn-14"><b> {{ use_language.button_save }} </b></span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog get employee -->
    <v-dialog v-model="dialogEmployee" scrollable max-width="50%" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1" class="ma-0">
        <v-card-title>
          <v-icon size="40" color="teal darken-3">mdi-account</v-icon>
           <span class="ml-3">{{ use_language.employee }}</span>
          <v-spacer/>
          <v-btn icon><v-icon color="danger" @click="dialogEmployee=false">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="overflow-y-auto px-5">
          <v-data-table
            :headers="employeeForSettingHeader"
            :items="employeeForSettingList"
            hide-default-footer
            :items-per-page="9999"
            :mobile-breakpoint="0"
          >
            <template v-slot:item.id="{ item }">
              <a class="color-blue" @click="openForSettingSalary(item)">{{ use_language.edit }}</a>
            </template>
            <template v-slot:item.name="{ item }">
              <div class="text-left">{{item.name}}</div>
            </template>
            <template v-slot:item.currentSalary="{ item }">
              <div class="text-right">
                {{item.currentSalary != null ? format_price(item.currentSalary) : null}}
              </div>
            </template>
            <template v-slot:item.isFulltime="{ item }">
              <div v-if="item.isFulltime != null" :class="item.isFulltime ? 'color-green' : 'color-orange'">
                {{item.isFulltime ? use_language.fulltime : use_language.parttime}}
              </div>
            </template>
            <template v-slot:item.isTakeSocialSecurity="{ item }">
              <div v-if="item.isTakeSocialSecurity != null" :class="item.isTakeSocialSecurity ? 'color-green' : 'color-orange'">
                {{item.isFulltime ? use_language.receive : use_language.not_receive}}
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- dialog srtting salary -->
    <v-dialog v-model="dialogSettingSalary" scrollable max-width="50%" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1" class="ma-0">
        <v-card-title>
          <v-icon size="40" color="teal darken-3">mdi-card-account-details-outline</v-icon>
           <span class="ml-3">{{ use_language.data_setting }}</span>
          <v-spacer/>
          <v-btn icon><v-icon color="danger" @click="closeForSettingSalary">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="overflow-y-auto px-5">
          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.name }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-text-field
                v-model="settingSalaryItem.firstname"
                autocomplete="off"
                outlined
                dense hide-details
                style="width: 212px"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.last_name }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-text-field
                v-model="settingSalaryItem.lastname"
                autocomplete="off"
                outlined
                dense hide-details
                style="width: 212px"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.salary }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-text-field
                v-model="settingSalaryItem.currentSalary"
                @keypress="isNumberWithDot($event)"
                autocomplete="off"
                outlined
                dense hide-details
                style="width: 212px"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.name_account }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-text-field
                v-model="settingSalaryItem.bankAccountName"
                autocomplete="off"
                outlined
                dense hide-details
                style="width: 212px"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.bank }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-text-field
                v-model="settingSalaryItem.bankName"
                autocomplete="off"
                outlined
                dense hide-details
                style="width: 212px"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.bank_number }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-text-field
                v-model="settingSalaryItem.bankAccountNumber"
                autocomplete="off"
                outlined
                dense hide-details
                style="width: 212px"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.category }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-radio-group row v-model="settingSalaryItem.isFulltime" dense hide-details>
                <v-radio :label="use_language.fulltime" :value="true"></v-radio>
                <v-radio :label="use_language.parttime" :value="false"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14">{{ use_language.social_security }} :</span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-radio-group row v-model="settingSalaryItem.isTakeSocialSecurity" dense hide-details>
                <v-radio :label="use_language.receive" :value="true"></v-radio>
                <v-radio :label="use_language.not_receive" :value="false"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn :elevation="1" color="primary" class="px-2" @click="updateSalaryStaff">
                <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
                <span class="fn-14"><b> {{ use_language.button_save }} </b></span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2"; 
import Loading from "@/website/components/Loading";
import { shopService_dotnet, branchService_dotnet } from "@/website/global";
import { AlertSuccess, AlertWarning, AlertError } from "@/website/global_alert";
import { format_price, formatDate_thai2, isNumberWithDot, DateNowNotNull, Trim_value, Trim_rules, get_languages } from "@/website/global_function";

// const shopService_dotnet = 'https://localhost:5001/';

export default {
  name: 'FrontWarehouseCalculateSalary',

  components: { Loading },

  data() {
    return {
      page_loading: true,
      use_language: {},
      loading: false,
      staffShopID: JSON.parse(localStorage.getItem("staff_id")),
      shopID: JSON.parse(localStorage.getItem("shop_id")),
      // branchID: 1,
      // staffBranchID: 8,
      header_token: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("authorization_token"),
      },

      //search
      search: { month: new Date().getMonth() + 1, year: new Date().getFullYear()},

      //salary info table
      salaryGetList: [],
      salaryPaymentList: [],
      textOfEmployee: null,
      employeeTakenIDList: [],
      allEmployeeList: [],
      selectedEmployeeNow: null,

      employeeList: [],

      salaryEmployeeList: [],

      salaryEmployerList: [],

      dialogWaitPay: false,
      selectedEmployeeWaitPay: [],
      employeeWaitPayList: [],

      dialogPayItem: false,
      isAddPayItem: false,
      descriptionType: null,
      payItem: {
        id: null,
        salaryMasterID: null,
        itemRowID: 0,
        name: null,
        type: null,
        description: null,
        in: null,
        out: null
      },
      
      dialogAddPayItem: false,
      bankAccountList: [],
      addPayItem: {
        id: null,
        salaryMasterID: null,
        selected_menu_date: false,
        selected_date: new Date(),
        bankAccountSelected: null,
        remark: null,
        amount: null

      },

      infoForAddItem: null,

      dialogEmployee: false,
      employeeForSettingList: [],

      dialogSettingSalary: false,
      settingSalaryItem: {
        id: null,
        firstname: null,
        lastname: null,
        currentSalary: null,
        isFulltime: null,
        bankName: null,
        bankAccountName: null,
        bankAccountNumber: null,
        isTakeSocialSecurity: null
      },

      rules: {
        firstname: [],
        lastname: [],
        currentSalary: [],
        bankName: [],
        bankAccountName: [],
        bankAccountNumber: []
      },
    };
  },

  mounted() {
    
  },

  async created() {
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
    // if (this.staffBranchID != 8) {
    //   this.page_loading = false;
    //   return
    // }
    await this.getShopBankAccount()
    await this.getEmployeeSalary()

    var currentdate = new Date();
    this.addPayItem.selected_date = currentdate.getFullYear()+"-"+(currentdate.getMonth()+1)+"-"+currentdate.getDate();

    // this.getShopBankAccount()

    this.page_loading = false;
  },

  watch: {
    descriptionType() {
      if (this.descriptionType == 1) {
        this.payItem.description = 'เบี้ยขยัน'
        this.payItem.in = 1000
      } else if (this.descriptionType == 2) {
        this.payItem.description = 'ค่าคอมมิสชั่น'
        this.payItem.in = null
      }
      
    }
  },

  computed: {
    computed_selected_date() {
      return this.formatDates(this.addPayItem.selected_date)
    },

    employeeHeader() {
      if (this.use_language == null) return []
      return [
        { align: "center", text: this.use_language.delete, value: "delete", sortable: false, width: "60px" },
        { align: "left", text: this.use_language.name, value: "name", sortable: false, width: "100px" },
        { align: "left", text: this.use_language.real_name, value: "fullName", sortable: false, width: "170px" },
        { align: "left", text: this.use_language.account, value: "bankName", sortable: false, width: "250px" },
        { align: "center", text: this.use_language.balance, value: "amount", sortable: false, width: "150px" },
        { align: "left", text: this.use_language.note, value: "remark", sortable: false, width: "150px" },
        { align: "center", text: this.use_language.category, value: "isFulltime", sortable: false, width: "60px" },
        { align: "center", text: this.use_language.social_security, value: "isTakeSocialSecurity", sortable: false , width: "100px"},
        { align: "center", text: this.use_language.social_security_percent, value: "socialPercent", sortable: false, width: "110px" },
        { align: "center", text: this.use_language.diligence_allowance, value: "specialWage", sortable: false, width: "100px" },
      ]
    },

    salaryEmployeeHeader() {
      if (this.use_language == null) return []
      return [
        { align: "center", text: this.use_language.edit, value: "edit", sortable: false, width: "60px" },
        { align: "center", text: this.use_language.delete, value: "delete", sortable: false, width: "60px" },
        { align: "left", text: this.use_language.details, value: "description", sortable: false, width: "170px" },
        { align: "center", text: this.use_language.receive, value: "payment", sortable: false, width: "100px" },
        { align: "center", text: this.use_language.deduct, value: "deduct", sortable: false, width: "100px" },
        { align: "center", text: this.use_language.balance, value: "total", sortable: false, width: "100px" },
        { align: "center", text: this.use_language.category, value: "salaryType", sortable: false, width: "100px" },
      ]
    },

    salaryEmployerHeader() {
      if (this.use_language == null) return []
      return [
        { align: "center", text: this.use_language.delete, value: "delete", sortable: false, width: "60px" },
        { align: "left", text: this.use_language.date, value: "paymentDate", sortable: false, width: "170px" },
        { align: "center", text: this.use_language.amount_money, value: "amount", sortable: false, width: "100px" },
        { align: "left", text: this.use_language.details, value: "description", sortable: false, width: "170px" },
        { align: "left", text: this.use_language.bank, value: "fullBankName", sortable: false, width: "170px" },
        { align: "left", text: this.use_language.by_, value: "createdByName", sortable: false, width: "100px" },
        { align: "left", text: this.use_language.creation_date, value: "created", sortable: false, width: "170px" },
        { align: "left", text: this.use_language.check, value: "checkedByName", sortable: false, width: "100px" },
        { align: "left", text: this.use_language.check_time, value: "checked", sortable: false, width: "170px" },
      ]
    },

    salaryTypeList() {
      if (this.use_language == null) return []
      return [
        {id: 1, text: this.use_language.salary},
        {id: 2, text: this.use_language.advance_withdrawal},
        {id: 3, text: this.use_language.social_security},
        {id: 4, text: this.use_language.commission},
        {id: 5, text: this.use_language.withholding},
        {id: 6, text: this.use_language.other},
      ]
    },

    employeeWaitPayHeader() {
      if (this.use_language == null) return []
      return [
        { align: "left", text: this.use_language.name, value: "name", sortable: false, width: "100px" },
        { align: "left", text: this.use_language.real_name, value: "firstname", sortable: false, width: "170px" },
        { align: "center", text: this.use_language.category, value: "isFulltime", sortable: false, width: "100px" },
      ]
    },

    employeeForSettingHeader() {
      if (this.use_language == null) return []
      return [
        { align: "center", text: this.use_language.edit, value: "id", sortable: false, width: "60px" },
        { align: "center", text: this.use_language.name, value: "name", sortable: false, width: "200px" },
        { align: "center", text: this.use_language.salary, value: "currentSalary", sortable: false, width: "170px" },
        { align: "center", text: this.use_language.category, value: "isFulltime", sortable: false, width: "100px" },
        { align: "center", text: this.use_language.social_security, value: "isTakeSocialSecurity", sortable: false, width: "100px" },
      ]
    },
  },
  
  methods: {
    format_price,
    formatDate_thai2,
    isNumberWithDot,
    get_languages,
    AlertSuccess, AlertWarning, AlertError,

    async getShopBankAccount() {
      let response = await axios.post(
        shopService_dotnet + 'Shop/get-shop-bank-list', 
        { "shopID": this.shopID },
        { headers:  this.header_token }
      )
      response.data.forEach(e => {
        if (e.isActive == true) {
          this.bankAccountList.push({text: e.bankID == 12 ? e.bankNameTH : e.fullBankName, id: e.id})
        }
      });
      
    },

    async getEmployeeSalary() {
      this.employeeTakenIDList = []
      let response = await axios.get(
        shopService_dotnet + "StaffShop/get-salary?ShopID=" + this.shopID + "&Year=" + this.search.year + "&Month=" + this.search.month,
        { headers: this.header_token }
      );
      if (response.data.length == 0) {
        this.employeeList = []
        this.salaryGetList = []
        this.salaryPaymentList = []
        this.infoForAddItem = null
        this.salaryEmployeeList = []
        this.salaryEmployerList = []
        this.textOfEmployee = null
        this.selectedEmployeeNow = null
        this.isAddPayItem = false
        return
      }
      var res = response.data
      this.salaryGetList = res
      var paymentList = [...new Set(res.map(i => i.id))];
      this.employeeTakenIDList = [...new Set(res.map(i => i.staffShopID))]
      
      var idStr = ""
      paymentList.forEach(e => {
        idStr = idStr + (idStr != "" ? "," : "") + e;
      });

      await this.getSalaryPayment(idStr)

      var list = []
      paymentList.forEach(e => {
        var obj = {}
        var infoAll = res.filter(i => i.id == e)
        
        var info = infoAll[0]
        var paid = this.salaryPaymentList.length > 0 ? this.salaryPaymentList.map(i => i.salaryMasterID == e ? i.amount : 0).reduce((a, b) => a + b) : 0;
        var specialWage = infoAll.filter(i => i.id == e && i.description == "เบี้ยขยัน");

        obj.id = info.id
        obj.name = info.name
        obj.fullName = info.fullName
        obj.bankName = info.bankName + " : " + info.bankAccountNumber + " : " + info.bankAccountName
        obj.amount = (infoAll.map(i => i.id == e ? i.amount : 0).reduce((a, b) => a + b).toFixed(2)) - paid.toFixed(2)
        obj.remark = info.remark
        obj.isFulltime = info.isFulltime ? this.use_language.fulltime : this.use_language.parttime
        obj.isTakeSocialSecurity = info.isTakeSocialSecurity ? this.use_language.receive : this.use_language.not_receive
        obj.socialPercent = info.socialPercent.toFixed(2)
        obj.specialWage = specialWage.length > 0 ? this.use_language.diligence_allowance : ""
        obj.staffShopID = info.staffShopID
        list.push(obj)
      });
      this.employeeList = list
    },

    async getSalaryPayment(value) {
      let response = await axios.get(
        shopService_dotnet + "StaffShop/get-salary-payment?SalaryMasterID=" + value,
        { headers: this.header_token }
      );
      this.salaryPaymentList = response.data
    },

    async getAllStaff() {
      let response = await axios.post(
        shopService_dotnet + "StaffShop/get-staffshop-salary-list",
        { shopId: this.shopID },
        { headers: this.header_token }
      );
      this.allEmployeeList = response.data
    },

    rowClick(item) {
      this.selectedDetailEmployee(item.id, item.name, item.staffShopID)
    },

    selectedDetailEmployee(id, name, staffID) {
      this.infoForAddItem = {id: id, name: name, staffID: staffID}
      this.salaryEmployeeList = []
      this.salaryEmployerList = []
      this.textOfEmployee = this.use_language.salary + ' : ' + name + ' ' + this.use_language.round + ' : ' + this.search.month + '/' + this.search.year
      var getSlr = this.salaryGetList.filter(i => i.id == id).sort((a, b) => a.itemRowID - b.itemRowID)
      var paySlr = this.salaryPaymentList.filter(i => i.salaryMasterID == id).sort((a, b) => a.id - b.id)

      //employee section
      if (getSlr.length > 0) {
        var getSlrList = []
        getSlr.forEach(e => {
          var obj = {}
          obj.id = e.id
          obj.description = e.description
          obj.payment = (e.amount > 0 ? e.amount : 0)
          obj.deduct = (e.amount < 0 ? e.amount : 0)
          obj.total = ''
          obj.salaryType = this.salaryTypeList.find(i => i.id == e.salaryType).text
          obj.itemRowID = e.itemRowID
          getSlrList.push(obj)
        });
        var payment = getSlrList.map(i => Number(i.payment)).reduce((a, b) => a + b)
        var deduct = getSlrList.map(i => Number(i.deduct)).reduce((a, b) => a + b)
        getSlrList.push(
          {
            id: 0,
            itemRowID: 0,
            description: '',
            payment: payment,
            deduct: deduct,
            total: payment + deduct,
            salaryType: '',
          }
        )
        this.salaryEmployeeList = getSlrList
      }

      //employer sction
      if (paySlr.length > 0) {
        var paySlrList = []
        paySlr.forEach(e => {
          var obj = {}
          obj.id = e.id
          obj.salaryMasterID = e.salaryMasterID
          obj.paymentDate = formatDate_thai2(e.paymentDate)
          obj.amount = format_price(e.amount)
          obj.description = e.description
          obj.fullBankName = e.fullBankName
          obj.createdByName = e.createdByName
          obj.created = formatDate_thai2(e.created)
          obj.checkedByName = e.checkedByName
          obj.checked = formatDate_thai2(e.checked)
          obj.isCash = e.isCash
          paySlrList.push(obj)
        });
        paySlrList.push(
          {
            id: 0,
            salaryMasterID: 0,
            paymentDate: '',
            amount: format_price(paySlr.map(i => Number(i.amount)).reduce((a, b) => a + b)),
            description: '',
            fullBankName: '',
            createdByName: '',
            created: '',
            checkedByName: '',
            checked: ''
          }
        )
        this.salaryEmployerList = paySlrList
      }

      this.selectedEmployeeNow = {staffId: staffID, name: name, salaryMasterID: id}
      this.isAddPayItem = true
    },

    async openDialogWaitPayEmployee() {
      await this.getAllStaff()
      this.employeeWaitPayList = this.allEmployeeList.filter(i => i.isActive == true && i.isDeleted == false && i.resignDate == null && !this.employeeTakenIDList.includes(i.id) && i.currentSalary != null && i.currentSalary > 0)
      this.dialogWaitPay = true
    },

    // async btnWaitPayEmployee() {
    //   var monthNow = this.search.year.toString().trim() + '-' + this.search.month.toString().trim() + '-' + 1
    //   var idList = this.selectedEmployeeWaitPay.map(i => i.id)
      
    //   var countSuccess = 1
    //   for (let i = 0; i < idList.length; i++) {
    //     let response = await axios.get(
    //       shopService_dotnet + "StaffShop/insert-salary-master?StaffShopID=" + idList[i] + "&date=" + monthNow,
    //       { headers: this.header_token }
    //     );
    //     if (response.status == 200) {
    //       countSuccess = countSuccess + i
    //     } else {
    //       this.AlertError()
    //       return
    //     }
    //   }
    //   if (countSuccess == idList.length) {
    //     await this.getEmployeeSalary()
    //     this.dialogWaitPay = false
    //     this.selectedEmployeeWaitPay = []
    //     this.successAlert()
    //   }
    // },

    async btnWaitPayEmployee() {
      var monthNow = this.search.year.toString().trim() + '-' + this.search.month.toString().trim() + '-' + 1
      var idList = this.selectedEmployeeWaitPay.map(i => i.id)
      let response = await axios.post(
        shopService_dotnet + "StaffShop/insert-salary-master-v2",
        {
          "staffShopID": idList,
          "date": monthNow
        },
        { headers: this.header_token }
      );
      if (response.data == "success") {
          await this.getEmployeeSalary()
          this.dialogWaitPay = false
          this.selectedEmployeeWaitPay = []
          this.successAlert()
        } else {
          this.AlertError(response.data)
          return
        }
    },

    async deletePayMaster(item) {
      Swal.fire({
        position: "top",
        icon: "warning",
        text: item.name + " " + this.use_language.confirm_delete_question,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          let response = await axios.get(
            shopService_dotnet + "StaffShop/delete-salary-master?SalaryMasterID=" + item.id,
            { headers: this.header_token }
          );
          if (response.status == 200) {
            this.salaryEmployeeList = []
            this.salaryEmployerList = []
            this.textOfEmployee = null
            this.selectedEmployeeNow = null
            this.isAddPayItem = false
            this.getEmployeeSalary()
            this.successAlert()
          }
        }
      });
    },

    async btnCalculateSalary() {
      let response = await axios.get(
        shopService_dotnet + "StaffShop/calculate-salary-to-expense?ShopID=" + this.shopID + "&StaffShopID=" + this.staffShopID + "&Year=" + this.search.year.toString().trim() + "&Month=" + this.search.month.toString().trim(),
        { headers: this.header_token }
      );
      if (response.status == 200) {
        await this.getEmployeeSalary()
        this.successAlert()
      }
    },

    async openPayItem(info) {
      if (info != null) {
        this.payItem.itemRowID = info.itemRowID
        this.payItem.type = this.salaryTypeList.find(i => i.text == info.salaryType).id
        this.payItem.description = info.description
        this.payItem.in = info.payment != null && info.payment > 0 ? info.payment  : null
        this.payItem.out = info.deduct != null && info.deduct < 0 ? (info.deduct * -1)  : null
      }
      this.payItem.id = this.selectedEmployeeNow.staffId
      this.payItem.name = this.selectedEmployeeNow.name
      this.payItem.salaryMasterID = this.selectedEmployeeNow.salaryMasterID
      this.dialogPayItem = true
    },

    closePayItem () {
      this.descriptionType = null
      this.payItem = {
        id: null, salaryMasterID: null, itemRowID: 0, name: null, 
        type: null, description: null, in: null, out: null
      }
      this.dialogPayItem = false
    },

    async btnUpdatePayItem() {
      var amount = null
      if (this.payItem.type == null) {
        this.AlertError(this.use_language.please_select_category)
        return
      }
      if (this.payItem.in != null && this.payItem.in.toString().trim() != '') {
        amount = Number(this.payItem.in)
      } else {
        amount = Number(this.payItem.out) * -1
      }
      let response = await axios.post(
        shopService_dotnet + "StaffShop/insert-salary-item",
        { 
          "id": this.payItem.itemRowID,
          "salaryMasterID": this.payItem.salaryMasterID,
          "description": this.payItem.description,
          "amount": amount,
          "created": new Date().toISOString(),
          "createdBy": this.staffShopID,
          "salaryType": this.payItem.type
        },
        { headers: this.header_token }
      );
      if (response.status == 200) {
        await this.getEmployeeSalary()
        await this.selectedDetailEmployee(this.infoForAddItem.id, this.infoForAddItem.name, this.infoForAddItem.staffID)
        this.closePayItem()
        this.successAlert()
      }  
    },

    async deletePayItem(item) {
      Swal.fire({
        position: "top",
        icon: "warning",
        text: item.description + " " + this.use_language.confirm_delete_question,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          let response = await axios.get(
            shopService_dotnet + "StaffShop/delete-salary-item?id=" + item.itemRowID,
            { headers: this.header_token }
          );
          if (response.status == 200) {
            this.salaryEmployeeList = this.salaryEmployeeList.filter(i => i.itemRowID !== item.itemRowID)

            var payment = this.salaryEmployeeList.map(i => i.itemRowID != 0 ? Number(i.payment) : 0).reduce((a, b) => a + b)
            var deduct = this.salaryEmployeeList.map(i => i.itemRowID != 0 ? Number(i.deduct) : 0).reduce((a, b) => a + b)
            var itemAmount = null

            this.salaryEmployeeList.map((i) => {
              if (i.itemRowID == 0) {
                i.payment = payment, i.deduct = deduct, i.total = payment + deduct, itemAmount = payment + deduct
              }
              return { ...i };
            });

            var index = this.salaryEmployerList.length - 1
            var payAmount = Number(this.salaryEmployerList[index].amount.replace(/,/g, ''))

            this.employeeList.map((i) => {
              if (i.id == item.id) {
                i.amount = itemAmount - payAmount
              }
              return { ...i };
            });
            this.successAlert()
          }
        }
      });
    },

    async openAddPayItem() {
      var salaryPayment = []
      var salaryItem = []
      let response1 = await axios.get(
        shopService_dotnet + "StaffShop/get-salary-payment?SalaryMasterID=" + this.selectedEmployeeNow.salaryMasterID,
        { headers: this.header_token }
      );
      if (response1.status == 200) {
        salaryPayment = response1.data
      } else {
        this.AlertError()
        return
      }

      let response2 = await axios.get(
        shopService_dotnet + "StaffShop/get-salary-item?MasterID=" + this.selectedEmployeeNow.salaryMasterID + "&RowID=" + 0,
        { headers: this.header_token }
      );
      if (response2.status == 200) {
        salaryItem = response2.data
      } else {
        this.AlertError()
        return
      }

      var amount = ((salaryItem.length == 0) ? 0 : salaryItem.reduce((sum, i) => sum + i.amount, 0)) - ((salaryPayment.length == 0) ? 0 : salaryPayment.reduce((sum, i) => sum + i.amount, 0));

      this.addPayItem.id = this.selectedEmployeeNow.staffId
      this.addPayItem.salaryMasterID = this.selectedEmployeeNow.salaryMasterID
      this.addPayItem.amount = amount
      this.dialogAddPayItem = true

    },

    closeAddPayItem () {
      var currentdate = new Date();
      this.addPayItem = {
        id: null,
        salaryMasterID: null,
        selected_menu_date: false,
        selected_date: currentdate.getFullYear()+"-"+(currentdate.getMonth()+1)+"-"+currentdate.getDate(),
        bankAccountSelected: null,
        remark: null,
        amount: null

      },
      this.dialogAddPayItem = false
    },

    async btnAddPayItem() {
      let response = await axios.post(
        shopService_dotnet + "StaffShop/update-salary-payment",
        { 
          "id": 0,
          "salaryMasterID": this.addPayItem.salaryMasterID,
          "bankID": this.addPayItem.bankAccountSelected,
          "paymentDate": this.addPayItem.selected_date,
          "amount": this.addPayItem.amount,
          "created": new Date().toISOString(),
          "createdBy": this.staffShopID,
          "description": this.addPayItem.remark,
        },
        { headers: this.header_token }
      );
      if (response.status == 200) {
        await this.getEmployeeSalary()
        await this.selectedDetailEmployee(this.infoForAddItem.id, this.infoForAddItem.name, this.infoForAddItem.staffID)
        this.closeAddPayItem()
        this.successAlert()
      }
    },

    async deleteAddPayItem(item) {
      Swal.fire({
        position: "top",
        icon: "warning",
        text: item.description + " " + this.use_language.confirm_delete_question,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          let response = await axios.get(
            shopService_dotnet + "StaffShop/delete-salary-payment?id=" + item.id,
            { headers: this.header_token }
          );
          if (response.status == 200) {
            var payAmount = 0
            if (this.salaryEmployerList.length > 2) {
              this.salaryEmployerList = this.salaryEmployerList.filter(i => i.id !== item.id)

              this.salaryEmployerList.map((i) => {
                if (i.id == 0) {
                  i.amount = format_price(this.salaryEmployerList.map(i => i.id != 0 ? Number(i.amount.replace(/,/g, '')) : 0).reduce((a, b) => a + b)),
                  payAmount = Number(this.salaryEmployerList.map(i => i.id != 0 ? Number(i.amount.replace(/,/g, '')) : 0).reduce((a, b) => a + b))
                }
                return { ...i };
              });
            } else {
              this.salaryEmployerList = []
            }

            var index = this.salaryEmployeeList.length - 1
            var itemAmount = Number(this.salaryEmployeeList[index].total)

            this.employeeList.map((i) => {
              if (i.id == item.salaryMasterID) {
                i.amount = itemAmount - payAmount
              }
              return { ...i };
            });
            this.successAlert()
          }
        }
      });
    },

    async openEmployeeForSetting() {
      this.dialogEmployee = true
      await this.getAllStaff()
      this.employeeForSettingList = this.allEmployeeList.filter(i => i.isActive == true && i.isDeleted == false && i.resignDate == null)
    },

    async openForSettingSalary(item) {
      this.settingSalaryItem = {
        id: item.id,
        firstname: item.firstname,
        lastname: item.lastname,
        currentSalary: item.currentSalary,
        isFulltime: item.isFulltime,
        bankName: item.bankName,
        bankAccountName: item.bankAccountName,
        bankAccountNumber: item.bankAccountNumber,
        isTakeSocialSecurity: item.isTakeSocialSecurity,
      }
      this.dialogSettingSalary = true
    },

    closeForSettingSalary() {
      this.dialogSettingSalary = false
      this.settingSalaryItem = {
        id: null,
        firstname: null,
        lastname: null,
        currentSalary: null,
        isFulltime: null,
        bankName: null,
        bankAccountName: null,
        bankAccountNumber: null,
        isTakeSocialSecurity: null
      }
    },

    async updateSalaryStaff() {
      var item = this.settingSalaryItem
      if (!item.firstname || !item.lastname || !item.currentSalary || !item.bankName 
        || !item.bankAccountName || !item.bankAccountNumber || item.isFulltime == null 
        || item.isTakeSocialSecurity == null) {
        this.AlertWarning(this.use_language.incomplete_data)
        return
      }
      let response = await axios.post(
        shopService_dotnet + "StaffShop/update-salary-staff",
        item,
        { headers: this.header_token }
      );
      if (response.data == 'success') {

        this.employeeForSettingList.map((i) => {
          if (i.id == item.id) {
            i.bankAccountName = item.bankAccountName, 
            i.bankAccountNumber = item.bankAccountNumber, 
            i.bankName = item.bankName, 
            i.currentSalary = item.currentSalary, 
            i.firstname = item.firstname, 
            i.lastname = item.lastname, 
            i.isFulltime = item.isFulltime,
            i.isTakeSocialSecurity = item.isTakeSocialSecurity
          }
          return { ...i };
        });

        this.successAlert()
        this.closeForSettingSalary()
      }
    },

    async successAlert(){
      Swal.fire({
        position: "top",
        icon: "success",
        toast: true,
        timer: 1500,
        showConfirmButton: false,
        type: 'success',
        title: 'Success'
      })
    },

    formatDates(date) {
      if(date == null){
        return null
      } else {
      const [year, month, day] = date.split('-')
        return `${year}-${month}-${day}`
      }
    },

  },
};
</script>
<style scoped>
.fill-height {
  height: 100dvh; /* ใช้ dynamic viewport สำหรับมือถือ */
}

.text-field-in input {
  color: green !important;
}

.text-field-out input {
  color: red !important;
}
</style>